import ExtraPriceDetails from "app/pages/Booking/Quotation/PriceDetails/ExtraPriceDetails/ExtraPriceDetails";
import {
	getEcheancierCasino,
	checkForSpecialOffer,
} from "app/pages/Booking/Payment/paymentSelector";
import { getIncludedTransfer } from "app/pages/Booking/Quotation/quotationSelectors";
import { PAYMENT_COUPON_TYPE } from "app/constants";
import {
	getUsableCreditNotesTotal,
	getUsableCreditsTotal,
} from "app/pages/Account/MyCoupons/couponSelector";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getLuggageTotalPrice } from "app/pages/Booking/bookingSelectors";
import { getSelectedActivitiesForPriceDetails } from "app/pages/Booking/Quotation/Activity/QuotationActivitySelectors";
import { getSpecialOffer } from "app/pages/FicheProduit/ficheProduitSelector";

const mapStateToProps = (state, ownProps) => {
	const booking = state.booking;
	// ownProps.match.url does not work here for holiday summary on mobile for example where ownProps.match.url = "booking"
	const isPagePayment = ownProps.location.pathname.includes("/booking/payment");
	const mensualite = getEcheancierCasino(state);

	return {
		includedTransfer: getIncludedTransfer(state),
		luggage: booking.luggage,
		luggageTotalPrice: getLuggageTotalPrice(state),
		accommodation: booking.accommodation,
		transfer: booking.transfer,
		offer: booking.offer,
		board: booking.board,
		flight: booking.flight,
		adults: booking.adults,
		infants: booking.infants,
		insurance: booking.insurance,
		totalUsableCredit:
			booking.coupon === PAYMENT_COUPON_TYPE.CREDIT ? getUsableCreditsTotal(state) : 0,
		totalUsableCreditNote: getUsableCreditNotesTotal(state),
		promotionValue:
			booking.coupon === PAYMENT_COUPON_TYPE.PROMOCODE ? state.promotion.promotionValue : 0,
		isPagePayment,
		paymentType: booking.paymentType,
		coutCreditCasino: mensualite.coutCredit,
		activities: getSelectedActivitiesForPriceDetails(state),
		usableCouponsStatus: state.usableCoupons.status,
		specialOffer: getSpecialOffer(state),
		isSpecialOfferActive: checkForSpecialOffer(state),
	};
};

export default withRouter(connect(mapStateToProps)(ExtraPriceDetails));
